import React, {useCallback, useState} from "react";
import {Alert, IconButton, Snackbar} from "@mui/material";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import {useTranslation} from "react-i18next";

export function CopyToClipboardButton(props: {
  text?: string
}) {
  const {t} = useTranslation();
  const [snackBarOpen, setSnackBarOpen] = useState(false);

  const handleSnackBarClose = (event: React.SyntheticEvent<any> | Event) => {
    setSnackBarOpen(false);
  };

  const handleCopy = useCallback(() => {
    props.text && navigator.clipboard.writeText(props.text);
    setSnackBarOpen(true);
  }, [props.text]);

  return (
    <>
      <IconButton onClick={handleCopy} disabled={!props.text}>
        <ContentCopyOutlinedIcon/>
      </IconButton>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackBarOpen}
        autoHideDuration={2000}
        onClose={handleSnackBarClose}
      >
        <Alert severity={"info"} onClose={handleSnackBarClose}>{t("common.copied")}</Alert>
      </Snackbar>
    </>
  )
}
